import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    dashboard: 'Tableau de bord',
    students: 'Élèves',
    teachers: 'Enseignants',
    classes: 'Classes & Niveaux',
    quranProgress: 'Progression Coranique',
    evaluations: 'Évaluations',
    grades: 'Notes',
    bulletins: 'Bulletins',
    attendance: 'Absences',
    payments: 'Paiements',
    mobilePayments: 'Paiements Mobiles',
    boardingFees: 'Tarifs Régimes',
    schoolYears: 'Années Scolaires',
    internat: 'Internat',
    parentPortal: 'Portail Parent',
    settings: 'Paramètres',
    users: 'Utilisateurs',
    rolesPermissions: 'Rôles & Permissions',
    
    // Common
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tous',
    actions: 'Actions',
    status: 'Statut',
    date: 'Date',
    name: 'Nom',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    notes: 'Notes',
    description: 'الوصف',
    type: 'Type',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    success: 'Succès',
    error: 'Erreur',
    confirm: 'Confirmer',
    details: 'Détails',
    back: 'Retour',
    close: 'Fermer',
    view: 'Voir',
    viewAll: 'Voir tout',
    active: 'Actif',
    inactive: 'Inactif',
    new: 'Nouveau',
    total: 'Total',
    create: 'Créer',
    update: 'Mettre à jour',
    refresh: 'Actualiser',
    export: 'Exporter',
    import: 'Importer',
    download: 'Télécharger',
    upload: 'Téléverser',
    yes: 'Oui',
    no: 'Non',
    
    // Dashboard specific
    dashboardTitle: 'Tableau de bord',
    dashboardSubtitle: 'Vue d\'ensemble de l\'établissement',
    totalStudents: 'Total élèves',
    activeStudents: 'Élèves actifs',
    totalTeachers: 'Total enseignants',
    totalPayments: 'Total paiements',
    pendingPayments: 'Paiements en attente',
    collectedPayments: 'Paiements collectés',
    recentActivity: 'Activité récente',
    recentStudents: 'Derniers inscrits',
    recentPayments: 'Derniers paiements',
    studentsByType: 'Répartition par type',
    paymentOverview: 'Aperçu des paiements',
    quranMemorization: 'Mémorisation du Coran',
    quickActions: 'Actions rapides',
    newStudent: 'Nouvel élève',
    newPayment: 'Nouveau paiement',
    manageAttendance: 'Gérer absences',
    viewReports: 'Voir rapports',
    hafiz: 'Hafiz',
    inProgress: 'En cours',
    collected: 'Collectés',
    pending: 'En attente',
    
    // Auth
    login: 'Connexion',
    logout: 'Déconnexion',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    loginTitle: 'Connexion',
    loginSubtitle: 'Entrez vos identifiants pour accéder à votre compte',
    loginButton: 'Se connecter',
    loginError: 'Email ou mot de passe incorrect',
    
    // Students
    student: 'Élève',
    studentList: 'Liste des élèves',
    addStudent: 'Ajouter un élève',
    editStudent: 'Modifier élève',
    studentDetails: 'Détails de l\'élève',
    studentType: 'Type d\'élève',
    quranic: 'Coranique',
    classical: 'Classique',
    mixed: 'Mixte',
    boardingType: 'Type de pensionnat',
    boarding: 'Interne',
    external: 'Externe',
    halfBoard: 'Demi-pensionnaire',
    birthDate: 'Date de naissance',
    birthPlace: 'Lieu de naissance',
    gender: 'Genre',
    male: 'Masculin',
    female: 'Féminin',
    matricule: 'Matricule',
    bloodGroup: 'Groupe sanguin',
    knownDiseases: 'Maladies connues',
    parentInfo: 'Informations des parents',
    fatherName: 'Nom du père',
    motherName: 'Nom de la mère',
    fatherPhone: 'Téléphone du père',
    motherPhone: 'Téléphone de la mère',
    fatherEmail: 'Email du père',
    motherEmail: 'Email de la mère',
    fatherJob: 'Profession du père',
    motherJob: 'Profession de la mère',
    contactWhatsApp: 'Contacter via WhatsApp',
    
    // Teachers
    teacher: 'Enseignant',
    teacherList: 'Liste des enseignants',
    addTeacher: 'Ajouter un enseignant',
    editTeacher: 'Modifier enseignant',
    teacherType: 'Type d\'enseignant',
    quranicTeacher: 'Enseignant coranique',
    classicalTeacher: 'Enseignant classique',
    subjects: 'Matières',
    assignedClasses: 'Classes assignées',
    
    // Classes
    class: 'Classe',
    classList: 'Liste des classes',
    addClass: 'Ajouter une classe',
    editClass: 'Modifier classe',
    level: 'Niveau',
    section: 'Section',
    academicYear: 'Année scolaire',
    studentsCount: 'Nombre d\'élèves',
    
    // Evaluations
    evaluation: 'Évaluation',
    evaluationList: 'Liste des évaluations',
    addEvaluation: 'Ajouter une évaluation',
    editEvaluation: 'Modifier évaluation',
    evaluationType: 'Type d\'évaluation',
    daily: 'Quotidienne',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuelle',
    trimestrial: 'Trimestrielle',
    semestrial: 'Semestrielle',
    coefficient: 'Coefficient',
    maxScore: 'Note maximale',
    enterGrades: 'Saisir les notes',
    
    // Payments
    payment: 'Paiement',
    paymentList: 'Liste des paiements',
    addPayment: 'Ajouter un paiement',
    editPayment: 'Modifier paiement',
    amount: 'Montant',
    paymentDate: 'Date de paiement',
    paymentMethod: 'Mode de paiement',
    cash: 'Espèces',
    bankTransfer: 'Virement bancaire',
    mobileMoney: 'Mobile Money',
    check: 'Chèque',
    paid: 'Payé',
    partial: 'Partiel',
    overdue: 'En retard',
    receipt: 'Reçu',
    generateReceipt: 'Générer reçu',
    
    // Roles & Permissions
    roles: 'Rôles',
    role: 'Rôle',
    rolesList: 'Liste des rôles',
    addRole: 'Nouveau rôle',
    editRole: 'Modifier rôle',
    deleteRole: 'Supprimer rôle',
    permissions: 'Permissions',
    permission: 'Permission',
    manageRoles: 'Gestion des Rôles et Permissions',
    configureAccess: 'Configurez les droits d\'accès pour chaque rôle',
    initDefaultRoles: 'Initialiser rôles par défaut',
    roleName: 'Nom du rôle',
    roleDisplayName: 'Nom d\'affichage',
    roleDescription: 'Description',
    dataScope: 'Portée des données',
    allData: 'Toutes les données',
    ownData: 'Ses propres données',
    assignedData: 'Données assignées',
    systemRole: 'Rôle système',
    customRole: 'Rôle personnalisé',
    cannotDeleteSystemRole: 'Les rôles système ne peuvent pas être supprimés',
    cannotEditAdminRole: 'Le rôle admin ne peut pas être modifié',
    roleCreated: 'Rôle créé avec succès',
    roleUpdated: 'Rôle mis à jour',
    roleDeleted: 'Rôle supprimé',
    availableModules: 'Modules disponibles',
    
    // Users Management
    user: 'Utilisateur',
    usersList: 'Liste des utilisateurs',
    addUser: 'Nouvel utilisateur',
    editUser: 'Modifier utilisateur',
    deleteUser: 'Supprimer utilisateur',
    userManagement: 'Gestion des Utilisateurs',
    manageAccounts: 'Gérez les comptes utilisateurs et leurs accès',
    userCreated: 'Utilisateur créé avec succès',
    userUpdated: 'Utilisateur mis à jour',
    userDeleted: 'Utilisateur supprimé',
    accountActive: 'Compte actif',
    linkedStudents: 'Élèves liés',
    linkedClasses: 'Classes liées',
    linkStudent: 'Lier un élève',
    unlinkStudent: 'Retirer le lien',
    linkClass: 'Lier une classe',
    unlinkClass: 'Retirer le lien',
    manageLinks: 'Gérer les liaisons',
    noLinkedStudents: 'Aucun élève lié',
    noLinkedClasses: 'Aucune classe liée',
    addStudent: 'Ajouter un élève',
    addClass: 'Ajouter une classe',
    
    // Internat
    internatDashboard: 'Gestion de l\'Internat',
    residentialLife: 'Vie résidentielle',
    housing: 'Hébergement',
    buildings: 'Bâtiments',
    rooms: 'Chambres',
    beds: 'Lits',
    availableBeds: 'Lits disponibles',
    occupiedBeds: 'Lits occupés',
    occupancyRate: 'Taux d\'occupation',
    boarders: 'Internes',
    halfBoarders: 'Demi-pensionnaires',
    externals: 'Externes',
    
    // Presence
    presence: 'Présence',
    boardingPresence: 'Présence Internat',
    dormitoryMorning: 'Dortoir Matin',
    dormitoryEvening: 'Dortoir Soir',
    breakfast: 'Petit-déjeuner',
    lunch: 'Déjeuner',
    dinner: 'Dîner',
    eveningStudy: 'Étude du soir',
    present: 'Présent',
    absent: 'Absent',
    excused: 'Excusé',
    late: 'Retard',
    markAllPresent: 'Tous présents',
    notMarked: 'Non marqué',
    
    // Exit Permissions
    exitPermissions: 'Permissions de sortie',
    newRequest: 'Nouvelle demande',
    approved: 'Approuvé',
    rejected: 'Refusé',
    cancelled: 'Annulé',
    approve: 'Approuver',
    reject: 'Refuser',
    weekend: 'Week-end',
    vacation: 'Vacances',
    emergency: 'Urgence',
    medical: 'Médical',
    family: 'Familial',
    destination: 'Destination',
    companion: 'Accompagnant',
    reason: 'Motif',
    startDate: 'Date début',
    endDate: 'Date fin',
    recordDeparture: 'Enregistrer départ',
    recordReturn: 'Enregistrer retour',
    departed: 'Parti',
    returned: 'Retourné',
    
    // Restauration
    restauration: 'Restauration',
    mealPlanning: 'Planification des repas',
    planMeal: 'Planifier un repas',
    menu: 'Menu',
    snack: 'Goûter',
    upcomingMeals: 'Prochains repas',
    noMealPlanned: 'Aucun repas planifié',
    
    // Medical
    medicalTracking: 'Suivi Médical',
    medicalRecords: 'Dossiers médicaux',
    newRecord: 'Nouvel enregistrement',
    visit: 'Visite',
    treatment: 'Traitement',
    vaccination: 'Vaccination',
    allergy: 'Allergie',
    accident: 'Accident',
    other: 'Autre',
    doctor: 'Médecin',
    followUp: 'Suivi prévu',
    urgent: 'Urgent',
    declaredAllergies: 'Allergies déclarées',
    activeTreatments: 'Traitements actifs',
    history: 'Historique',
    
    // Buildings
    building: 'Bâtiment',
    addBuilding: 'Ajouter bâtiment',
    floor: 'Étage',
    floors: 'Étages',
    boys: 'Garçons',
    girls: 'Filles',
    
    // Rooms
    room: 'Chambre',
    addRoom: 'Ajouter chambre',
    dormitory: 'Dortoir',
    singleRoom: 'Individuelle',
    doubleRoom: 'Double',
    capacity: 'Capacité',
    
    // Beds
    bed: 'Lit',
    addBeds: 'Ajouter lits',
    bedNumber: 'Numéro de lit',
    assign: 'Attribuer',
    release: 'Libérer',
    assigned: 'Attribué',
    available: 'Disponible',
    
    // CSV Import/Export
    importStudents: 'Importer des élèves',
    exportStudents: 'Exporter les élèves',
    downloadTemplate: 'Télécharger le modèle',
    csvImportSuccess: 'Importation réussie',
    csvExportSuccess: 'Exportation réussie',
    
    // Notifications
    sendNotification: 'Envoyer une notification',
    emailNotification: 'Notification par email',
    whatsappNotification: 'Notification WhatsApp',
    notificationSent: 'Notification envoyée',
    
    // Mobile Payments
    generatePaymentLink: 'Générer un lien de paiement',
    paymentLink: 'Lien de paiement',
    wave: 'Wave',
    orangeMoney: 'Orange Money',
    paymentPending: 'Paiement en attente',
    paymentCompleted: 'Paiement effectué',
  },
  
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    students: 'الطلاب',
    teachers: 'المعلمون',
    classes: 'الفصول والمستويات',
    quranProgress: 'تقدم القرآن',
    evaluations: 'التقييمات',
    grades: 'الدرجات',
    bulletins: 'الشهادات',
    attendance: 'الغياب',
    payments: 'المدفوعات',
    mobilePayments: 'الدفع بالهاتف',
    boardingFees: 'رسوم الإقامة',
    schoolYears: 'السنوات الدراسية',
    internat: 'الداخلية',
    parentPortal: 'بوابة الوالدين',
    settings: 'الإعدادات',
    users: 'المستخدمون',
    rolesPermissions: 'الأدوار والصلاحيات',
    
    // Common
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    all: 'الكل',
    actions: 'الإجراءات',
    status: 'الحالة',
    date: 'التاريخ',
    name: 'الاسم',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    notes: 'ملاحظات',
    description: 'الوصف',
    type: 'النوع',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    success: 'نجاح',
    error: 'خطأ',
    confirm: 'تأكيد',
    details: 'تفاصيل',
    back: 'رجوع',
    close: 'إغلاق',
    view: 'عرض',
    viewAll: 'عرض الكل',
    active: 'نشط',
    inactive: 'غير نشط',
    new: 'جديد',
    total: 'المجموع',
    create: 'إنشاء',
    update: 'تحديث',
    refresh: 'تحديث',
    export: 'تصدير',
    import: 'استيراد',
    download: 'تحميل',
    upload: 'رفع',
    yes: 'نعم',
    no: 'لا',
    
    // Dashboard specific
    dashboardTitle: 'لوحة التحكم',
    dashboardSubtitle: 'نظرة عامة على المؤسسة',
    totalStudents: 'إجمالي الطلاب',
    activeStudents: 'الطلاب النشطون',
    totalTeachers: 'إجمالي المعلمين',
    totalPayments: 'إجمالي المدفوعات',
    pendingPayments: 'مدفوعات معلقة',
    collectedPayments: 'مدفوعات محصلة',
    recentActivity: 'النشاط الأخير',
    recentStudents: 'آخر المسجلين',
    recentPayments: 'آخر المدفوعات',
    studentsByType: 'التوزيع حسب النوع',
    paymentOverview: 'نظرة على المدفوعات',
    quranMemorization: 'حفظ القرآن',
    quickActions: 'إجراءات سريعة',
    newStudent: 'طالب جديد',
    newPayment: 'دفعة جديدة',
    manageAttendance: 'إدارة الغياب',
    viewReports: 'عرض التقارير',
    hafiz: 'حافظ',
    inProgress: 'قيد التقدم',
    collected: 'محصل',
    pending: 'قيد الانتظار',
    
    // Auth
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    password: 'كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    loginTitle: 'تسجيل الدخول',
    loginSubtitle: 'أدخل بياناتك للوصول إلى حسابك',
    loginButton: 'دخول',
    loginError: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    
    // Students
    student: 'طالب',
    studentList: 'قائمة الطلاب',
    addStudent: 'إضافة طالب',
    editStudent: 'تعديل الطالب',
    studentDetails: 'تفاصيل الطالب',
    studentType: 'نوع الطالب',
    quranic: 'قرآني',
    classical: 'كلاسيكي',
    mixed: 'مختلط',
    boardingType: 'نوع الإقامة',
    boarding: 'داخلي',
    external: 'خارجي',
    halfBoard: 'نصف داخلي',
    birthDate: 'تاريخ الميلاد',
    birthPlace: 'مكان الميلاد',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    matricule: 'رقم التسجيل',
    bloodGroup: 'فصيلة الدم',
    knownDiseases: 'الأمراض المعروفة',
    parentInfo: 'معلومات الوالدين',
    fatherName: 'اسم الأب',
    motherName: 'اسم الأم',
    fatherPhone: 'هاتف الأب',
    motherPhone: 'هاتف الأم',
    fatherEmail: 'بريد الأب',
    motherEmail: 'بريد الأم',
    fatherJob: 'مهنة الأب',
    motherJob: 'مهنة الأم',
    contactWhatsApp: 'التواصل عبر واتساب',
    
    // Teachers
    teacher: 'معلم',
    teacherList: 'قائمة المعلمين',
    addTeacher: 'إضافة معلم',
    editTeacher: 'تعديل المعلم',
    teacherType: 'نوع المعلم',
    quranicTeacher: 'معلم قرآن',
    classicalTeacher: 'معلم كلاسيكي',
    subjects: 'المواد',
    assignedClasses: 'الفصول المعينة',
    
    // Classes
    class: 'فصل',
    classList: 'قائمة الفصول',
    addClass: 'إضافة فصل',
    editClass: 'تعديل الفصل',
    level: 'المستوى',
    section: 'الشعبة',
    academicYear: 'السنة الدراسية',
    studentsCount: 'عدد الطلاب',
    
    // Evaluations
    evaluation: 'تقييم',
    evaluationList: 'قائمة التقييمات',
    addEvaluation: 'إضافة تقييم',
    editEvaluation: 'تعديل التقييم',
    evaluationType: 'نوع التقييم',
    daily: 'يومي',
    weekly: 'أسبوعي',
    monthly: 'شهري',
    trimestrial: 'فصلي',
    semestrial: 'نصف سنوي',
    coefficient: 'المعامل',
    maxScore: 'الدرجة القصوى',
    enterGrades: 'إدخال الدرجات',
    
    // Payments
    payment: 'دفعة',
    paymentList: 'قائمة المدفوعات',
    addPayment: 'إضافة دفعة',
    editPayment: 'تعديل الدفعة',
    amount: 'المبلغ',
    paymentDate: 'تاريخ الدفع',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقداً',
    bankTransfer: 'تحويل بنكي',
    mobileMoney: 'موبايل موني',
    check: 'شيك',
    paid: 'مدفوع',
    partial: 'جزئي',
    overdue: 'متأخر',
    receipt: 'إيصال',
    generateReceipt: 'إنشاء إيصال',
    
    // Roles & Permissions
    roles: 'الأدوار',
    role: 'دور',
    rolesList: 'قائمة الأدوار',
    addRole: 'دور جديد',
    editRole: 'تعديل الدور',
    deleteRole: 'حذف الدور',
    permissions: 'الصلاحيات',
    permission: 'صلاحية',
    manageRoles: 'إدارة الأدوار والصلاحيات',
    configureAccess: 'تكوين حقوق الوصول لكل دور',
    initDefaultRoles: 'تهيئة الأدوار الافتراضية',
    roleName: 'اسم الدور',
    roleDisplayName: 'اسم العرض',
    roleDescription: 'الوصف',
    dataScope: 'نطاق البيانات',
    allData: 'جميع البيانات',
    ownData: 'بياناته الخاصة',
    assignedData: 'البيانات المعينة',
    systemRole: 'دور النظام',
    customRole: 'دور مخصص',
    cannotDeleteSystemRole: 'لا يمكن حذف أدوار النظام',
    cannotEditAdminRole: 'لا يمكن تعديل دور المدير',
    roleCreated: 'تم إنشاء الدور بنجاح',
    roleUpdated: 'تم تحديث الدور',
    roleDeleted: 'تم حذف الدور',
    availableModules: 'الوحدات المتاحة',
    
    // Users Management
    user: 'مستخدم',
    usersList: 'قائمة المستخدمين',
    addUser: 'مستخدم جديد',
    editUser: 'تعديل المستخدم',
    deleteUser: 'حذف المستخدم',
    userManagement: 'إدارة المستخدمين',
    manageAccounts: 'إدارة حسابات المستخدمين وصلاحياتهم',
    userCreated: 'تم إنشاء المستخدم بنجاح',
    userUpdated: 'تم تحديث المستخدم',
    userDeleted: 'تم حذف المستخدم',
    accountActive: 'حساب نشط',
    linkedStudents: 'الطلاب المرتبطون',
    linkedClasses: 'الفصول المرتبطة',
    linkStudent: 'ربط طالب',
    unlinkStudent: 'إلغاء الربط',
    linkClass: 'ربط فصل',
    unlinkClass: 'إلغاء الربط',
    manageLinks: 'إدارة الروابط',
    noLinkedStudents: 'لا يوجد طلاب مرتبطون',
    noLinkedClasses: 'لا توجد فصول مرتبطة',
    
    // Internat
    internatDashboard: 'إدارة الداخلية',
    residentialLife: 'الحياة السكنية',
    housing: 'السكن',
    buildings: 'المباني',
    rooms: 'الغرف',
    beds: 'الأسرّة',
    availableBeds: 'أسرّة متاحة',
    occupiedBeds: 'أسرّة مشغولة',
    occupancyRate: 'نسبة الإشغال',
    boarders: 'الطلاب الداخليون',
    halfBoarders: 'نصف الداخليين',
    externals: 'الخارجيون',
    
    // Presence
    presence: 'الحضور',
    boardingPresence: 'حضور الداخلية',
    dormitoryMorning: 'المبيت صباحاً',
    dormitoryEvening: 'المبيت مساءً',
    breakfast: 'الفطور',
    lunch: 'الغداء',
    dinner: 'العشاء',
    eveningStudy: 'المذاكرة المسائية',
    present: 'حاضر',
    absent: 'غائب',
    excused: 'معذور',
    late: 'متأخر',
    markAllPresent: 'الكل حاضر',
    notMarked: 'غير محدد',
    
    // Exit Permissions
    exitPermissions: 'أذونات الخروج',
    newRequest: 'طلب جديد',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    cancelled: 'ملغى',
    approve: 'موافقة',
    reject: 'رفض',
    weekend: 'نهاية الأسبوع',
    vacation: 'إجازة',
    emergency: 'طوارئ',
    medical: 'طبي',
    family: 'عائلي',
    destination: 'الوجهة',
    companion: 'المرافق',
    reason: 'السبب',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    recordDeparture: 'تسجيل المغادرة',
    recordReturn: 'تسجيل العودة',
    departed: 'غادر',
    returned: 'عاد',
    
    // Restauration
    restauration: 'المطعم',
    mealPlanning: 'تخطيط الوجبات',
    planMeal: 'تخطيط وجبة',
    menu: 'القائمة',
    snack: 'وجبة خفيفة',
    upcomingMeals: 'الوجبات القادمة',
    noMealPlanned: 'لا توجد وجبات مخططة',
    
    // Medical
    medicalTracking: 'المتابعة الطبية',
    medicalRecords: 'السجلات الطبية',
    newRecord: 'سجل جديد',
    visit: 'زيارة',
    treatment: 'علاج',
    vaccination: 'تطعيم',
    allergy: 'حساسية',
    accident: 'حادث',
    other: 'أخرى',
    doctor: 'الطبيب',
    followUp: 'موعد المتابعة',
    urgent: 'عاجل',
    declaredAllergies: 'الحساسيات المعلنة',
    activeTreatments: 'العلاجات النشطة',
    history: 'التاريخ',
    
    // Buildings
    building: 'مبنى',
    addBuilding: 'إضافة مبنى',
    floor: 'طابق',
    floors: 'طوابق',
    boys: 'ذكور',
    girls: 'إناث',
    
    // Rooms
    room: 'غرفة',
    addRoom: 'إضافة غرفة',
    dormitory: 'عنبر',
    singleRoom: 'فردية',
    doubleRoom: 'مزدوجة',
    capacity: 'السعة',
    
    // Beds
    bed: 'سرير',
    addBeds: 'إضافة أسرّة',
    bedNumber: 'رقم السرير',
    assign: 'تخصيص',
    release: 'إخلاء',
    assigned: 'مخصص',
    available: 'متاح',
    
    // CSV Import/Export
    importStudents: 'استيراد الطلاب',
    exportStudents: 'تصدير الطلاب',
    downloadTemplate: 'تحميل القالب',
    csvImportSuccess: 'تم الاستيراد بنجاح',
    csvExportSuccess: 'تم التصدير بنجاح',
    
    // Notifications
    sendNotification: 'إرسال إشعار',
    emailNotification: 'إشعار بالبريد',
    whatsappNotification: 'إشعار واتساب',
    notificationSent: 'تم إرسال الإشعار',
    
    // Mobile Payments
    generatePaymentLink: 'إنشاء رابط الدفع',
    paymentLink: 'رابط الدفع',
    wave: 'ويف',
    orangeMoney: 'أورانج موني',
    paymentPending: 'الدفع قيد الانتظار',
    paymentCompleted: 'تم الدفع',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['fr'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'ar' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

export default LanguageContext;
